import fd from 'fastdom'
import fastdomPromised from 'fastdom/extensions/fastdom-promised'
// extend fastdom
export const fastdom = fd.extend(fastdomPromised)
